import React, { useState, useMemo } from 'react';
import { MdUnfoldMore } from 'react-icons/md';

import { FormikHelpers } from 'formik';

import BottomSheetOptions from 'components/BottomSheetOptions';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { ButtonSelect, Text, Error } from './styles';

interface Data {
  id: string;
  name: string;
}

interface OnboardingSelectProps {
  disabled?: boolean;
  title: string;
  value?: string;
  options: Data[];
  type?: string;
  onChange?: (value: any) => void;
  onClose?: () => void;
  name?: string;
  formik?: FormikHelpers<string>;
  error?: string;
  enableSearch?: boolean;
}

const OnboardingSelect = ({
  name,
  title,
  disabled,
  value,
  options,
  formik,
  onChange,
  error,
  enableSearch,
}: OnboardingSelectProps) => {
  const { t } = useStoreTranslation();
  const [showSelect, setSelect] = useState(false);

  const item = useMemo(() => options.find((op) => op.id === value), [value, options]);

  const handleShowSelect = () => {
    setSelect(true);
  };

  const handleChange = (value: string) => {
    if (formik && name) {
      formik?.setFieldValue(name, value);
    } else if (onChange) {
      onChange(value);
    }
  };

  return (
    <div>
      <ButtonSelect disabled={disabled} type="button" id="rule-name" onClick={handleShowSelect} $error={!!error}>
        <Text>{!item ? t('rulesComponent.rulesSelect') : item?.name}</Text> <MdUnfoldMore />
      </ButtonSelect>
      <BottomSheetOptions
        style={{ maxHeight: 500, overflowY: 'scroll' }}
        title={title}
        show={showSelect}
        data={options}
        onClose={() => setSelect(false)}
        onChange={handleChange}
        enableSearch={enableSearch}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default OnboardingSelect;
